import { IClassListItem } from "../model/respone/classes/IClassListItem";

/**
 * Mirror backend `Service/CongDangKy/Helpers/MonChungHelper.cs`.
 *
 * Hai môn chung móc nối (PLAN_MonHocChung) CÙNG nhóm lớp được học xen kẽ cùng khung giờ
 * (bỏ qua trùng lịch) NHƯNG phải đăng ký cùng "số lớp": đã ĐK Đọc-Viết 5 lớp 1 thì
 * Nghe-Nói 5 cũng phải lớp 1. Dùng cho optimistic-update sau register/cancel.
 */

/**
 * "Số lớp" (index) — đoạn cuối (sau '.') của phần trước '_' trong tên lớp.
 * VD "TADV5CQ62.51.2.1_LT" → "1", "TANN5CQ62.51.2.2_LT" → "2".
 */
export const getLopIndex = (tenLopHp?: string): string => {
    if (!tenLopHp) return "";
    let s = tenLopHp.trim();
    const us = s.indexOf("_");
    if (us >= 0) s = s.substring(0, us);
    const dot = s.lastIndexOf(".");
    if (dot >= 0 && dot < s.length - 1) s = s.substring(dot + 1);
    return s.trim();
};

/**
 * a, b là cặp môn chung móc nối CÙNG nhóm lớp (>0) → được học xen kẽ.
 * Điều kiện khớp backend ScheduleConflictChecker exemption + rule khớp lớp.
 */
export const isMonChungPair = (a?: IClassListItem, b?: IClassListItem): boolean => {
    if (!a || !b) return false;
    const aNhom = a.stu_nhomlop_ids ?? 0;
    const bNhom = b.stu_nhomlop_ids ?? 0;
    if (aNhom <= 0 || aNhom !== bNhom) return false;
    return !!a.mon_chung_ids?.includes(b.id_mon);
};

/** Cặp môn chung cùng nhóm lớp NHƯNG lệch "số lớp" → phải chặn. */
export const isMonChungIndexMismatch = (a?: IClassListItem, b?: IClassListItem): boolean => {
    if (!isMonChungPair(a, b)) return false;
    return getLopIndex(a!.ten_lop_hp) !== getLopIndex(b!.ten_lop_hp);
};
